/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_Updating_ProfileInputs */

const en_us2_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating your profile…`)
};

const pt_br2_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizando o seu perfil…`)
};

const es_419_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizando tu perfil…`)
};

const pt_pt2_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A atualizar o teu perfil…`)
};

const fr_fr2_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour de ton profil…`)
};

const de_de2_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiere dein Profil…`)
};

const it_it2_coach_extra_activity_updating_profile = /** @type {(inputs: Coach_Extra_Activity_Updating_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorno il tuo profilo…`)
};

/**
* | output |
* | --- |
* | "Updating your profile…" |
*
* @param {Coach_Extra_Activity_Updating_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_updating_profile = /** @type {((inputs?: Coach_Extra_Activity_Updating_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_Updating_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_updating_profile(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_updating_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_updating_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_updating_profile(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_updating_profile(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_updating_profile(inputs)
	return en_us2_coach_extra_activity_updating_profile(inputs)
});
export { coach_extra_activity_updating_profile as "coach-extra.activity_updating_profile" }